import { createAction } from '@reduxjs/toolkit';

import { type IAuditRequest } from './types';

export const getDocumentHistory = createAction<string>('getDocumentHistory');

export const getVersionComparison = createAction<IAuditRequest>('getVersionComparison');
